export function Course__IsPriceFrom(course: any) {
  return course.price !== undefined
    ? course.isPriceFrom
    : course.summary?.additionalPrices?.length > 0;
}
